import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

// Mock data for goal collections
/* const mockGoalCollections = [
  {
    id: 1,
    title: 'Sustainable Development Goals',
    description: 'United Nations sustainable development goals for urban planning',
    frameworkId: 1,
    countryId: 1,
    goals: [
      {
        id: 101,
        subCategoryId: 430,
        text: 'Reduce carbon emissions by 50% by 2030',
        rating: 40,
        isActivated: true,
      },
      {
        id: 102,
        subCategoryId: 1,
        text: 'Increase renewable energy usage to 75%',
        rating: 30,
        isActivated: true,
      },
      {
        id: 103,
        subCategoryId: 2,
        text: 'Ensure equal access to public services',
        rating: 40,
        isActivated: true,
      },
      {
        id: 104,
        subCategoryId: 3,
        text: 'Create sustainable economic growth',
        rating: 20,
        isActivated: true,
      },
      {
        id: 105,
        subCategoryId: 4,
        text: 'Implement transparent decision-making processes',
        rating: 4,
        isActivated: true,
      },
      {
        id: 106,
        subCategoryId: 5,
        text: 'Develop resilient infrastructure',
        rating: 3,
        isActivated: true,
      },
    ],
  },
  {
    id: 2,
    title: 'Smart City Goals',
    description: 'Goals for developing technology-enabled urban environments',
    frameworkId: 1,
    countryId: 1,
    goals: [
      {
        id: 201,
        subCategoryId: 1,
        text: 'Implement IoT sensors throughout urban areas',
        rating: 4,
        isActivated: true,
      },
      {
        id: 202,
        subCategoryId: 2,
        text: 'Establish high-speed broadband for all citizens',
        rating: 5,
        isActivated: true,
      },
      {
        id: 203,
        subCategoryId: 3,
        text: 'Create open data platforms for city information',
        rating: 3,
        isActivated: true,
      },
      {
        id: 204,
        subCategoryId: 4,
        text: 'Enhance cybersecurity for all city systems',
        rating: 4,
        isActivated: true,
      },
      {
        id: 205,
        subCategoryId: 200,
        text: 'Establish innovation hubs and incubators',
        rating: 4,
        isActivated: true,
      },
    ],
  },
  {
    id: 3,
    title: 'Green Building Standards',
    description: 'Ecological construction and building management goals',
    frameworkId: 3,
    countryId: 1,
    goals: [
      {
        id: 301,
        subCategoryId: 11,
        text: 'Reduce building energy consumption by 40%',
        rating: 3,
        isActivated: true,
      },
      {
        id: 302,
        subCategoryId: 12,
        text: 'Implement water recycling systems',
        rating: 4,
        isActivated: true,
      },
      {
        id: 303,
        subCategoryId: 13,
        text: 'Use sustainable and local building materials',
        rating: 5,
        isActivated: true,
      },
      {
        id: 304,
        subCategoryId: 14,
        text: 'Enhance indoor air quality standards',
        rating: 3,
        isActivated: true,
      },
      {
        id: 305,
        subCategoryId: 15,
        text: 'Maximize biodiversity in surrounding areas',
        rating: 4,
        isActivated: true,
      },
    ],
  },
  {
    id: 4,
    title: 'Mobility & Transport',
    description: 'Sustainable urban mobility and transportation goals',
    frameworkId: 2,
    countryId: 1,
    goals: [
      {
        id: 401,
        subCategoryId: 16,
        text: 'Expand public transit coverage to 95% of urban areas',
        rating: 3,
        isActivated: true,
      },
      {
        id: 402,
        subCategoryId: 17,
        text: 'Create 200km of dedicated bike lanes',
        rating: 4,
        isActivated: true,
      },
      {
        id: 403,
        subCategoryId: 18,
        text: 'Install EV charging stations every 5km',
        rating: 2,
        isActivated: true,
      },
      {
        id: 404,
        subCategoryId: 19,
        text: 'Implement city-wide bike and scooter sharing',
        rating: 4,
        isActivated: true,
      },
      {
        id: 405,
        subCategoryId: 20,
        text: 'Ensure all transit is accessible to people with disabilities',
        rating: 3,
        isActivated: true,
      },
    ],
  },
] */

class GoalCollections extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'GoalCollections'
  // Define default properties here
  static instanceDefaults () {
    return {
      visibility: 'private',
      isEnabled: false,
      userId: null,
      organizationId: null,
      mediaId: null,
      frameworkId: null,
      countryId: null,
      title: null,
      description: null,
      translations: [],
    }
  }
}
const servicePath = 'goal-collections'
const servicePlugin = makeServicePlugin({
  Model: GoalCollections,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})
/* servicePlugin.state = {
  ids: [],
  keyedById: {},
}
// Initialize the service with mock data
servicePlugin.state.ids.forEach(id => {
  servicePlugin.state.keyedById[id] = null
})

// Add mock data to the store on initialization
mockGoalCollections.forEach(collection => {
  servicePlugin.state.ids.push(collection.id)
  servicePlugin.state.keyedById[collection.id] = collection
}) */

export default servicePlugin
